import { Storage } from "@ionic/storage";

export class StorageProvider<T>{
    constructor(private storage: Storage, private key: string) {

    }

    async get(): Promise<StorageResult<T>> {
        var x = await this.storage.get(this.key) as T;
        return new StorageResult<T>(x);
    }

    async set(obj: T): Promise<T> {
        return this.storage.set(this.key, obj);
    }

    async remove(): Promise<T> {
        return this.storage.remove(this.key);
    }
}

class StorageResult<T> {
    constructor(data: T) {
        if(data){
            this.available = true;
            this.data = data;
        } else {
            this.available = false;
        }
    }

    public available: boolean;
    public data: T;
}


// WEBPACK FOOTER //
// ./src/providers/storage/storage.ts